import type { TraceErrorObject } from 'owa-trace';

import { addErrorToCustomData } from 'owa-analytics-utils/lib/addErrorToCustomData';
import { addFinalErrorFieldsToCustomData, ignoreError } from 'owa-analytics-utils/lib/ignoreError';

import ErrorDatapoint from '../../datapoints/ErrorDatapoint';
import UsageDatapoint from '../../datapoints/UsageDatapoint';
import { logDatapoint } from '../logDatapoint';

const GREY_ERROR_TABLE = 'client_grey_error';

interface ErrorDatapointOptions {
    logInDevMode: boolean;
    errorVersion: number;
    isCreateRootOn: boolean;
}

export function logErrorDatapoint(
    message: string,
    errorDetails: TraceErrorObject | undefined,
    options?: ErrorDatapointOptions
): void {
    try {
        if (ignoreError(message)) {
            return;
        }

        const { datapointName, customData } = addErrorToCustomData(message, errorDetails);

        // This is to allow for filtering dev-mode datapoints in a query where we don't have a reliable build number
        if (options) {
            customData.errorVersion = options.errorVersion;
            customData.isCreateRootOn = options.isCreateRootOn;
        }

        if (datapointName) {
            logDatapoint(new UsageDatapoint(datapointName, customData), GREY_ERROR_TABLE);
        } else {
            const { customData: customDataWithFinalFields, table } =
                addFinalErrorFieldsToCustomData(
                    message,
                    errorDetails,
                    customData,
                    options?.logInDevMode
                );

            logDatapoint(
                new ErrorDatapoint(message, errorDetails, customDataWithFinalFields),
                table
            );
        }
    } catch {
        // TODO OW 48077
    }
}
